import React, { useEffect, useMemo } from "react";
import { Grid } from "@mui/material";
import {
  CommitteeObjectSelect,
  FactorSelect,
} from "../Select/domainSelects";
import {
  shouldShowCommitteeObject,
  shouldShowFactor,
} from "../../functions/factorObjectVisibility";

/**
 * Условные поля «Фактор» / «Объект» для постановления и предписания.
 * Фактор — при цели «Санитарно-эпидемиологический мониторинг».
 * Объект — при факторе «Водные ресурсы» (иерархия factor → committeeObject).
 */
export default function FactorObjectFields({
  disabled,
  purpose,
  factor,
  factorId,
  objectId,
  setValue,
}) {
  const showFactor = useMemo(() => shouldShowFactor(purpose), [purpose]);
  const showObject = useMemo(
    () => shouldShowCommitteeObject(purpose, factor),
    [purpose, factor]
  );

  useEffect(() => {
    if (showFactor) return;
    setValue("factorId", null);
    setValue("factor", null);
    setValue("objectId", null);
    setValue("committeeObject", null);
  }, [showFactor, setValue]);

  useEffect(() => {
    if (showObject) return;
    // Пока фактор выбран, но сущность ещё не подгружена — не сбрасываем objectId
    if (factorId && !factor?.name) return;
    setValue("objectId", null);
    setValue("committeeObject", null);
  }, [showObject, factorId, factor, setValue]);

  if (!showFactor) {
    return null;
  }

  return (
    <>
      <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
        <p style={{ width: "50%" }}>Фактор</p>
        <FactorSelect
          disabled={disabled}
          fullWidth
          required
          formStyle={{ width: "50%", marginLeft: "30px" }}
          value={factorId}
          onChange={(val, opt) => {
            setValue("factorId", val);
            setValue("factor", opt || null);
            setValue("objectId", null);
            setValue("committeeObject", null);
          }}
        />
      </Grid>
      {showObject && (
        <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
          <p style={{ width: "50%" }}>Объект</p>
          <CommitteeObjectSelect
            disabled={disabled}
            fullWidth
            required
            factorId={factorId}
            formStyle={{ width: "50%", marginLeft: "30px" }}
            value={objectId}
            onChange={(val, opt) => {
              setValue("objectId", val);
              setValue("committeeObject", opt || null);
            }}
          />
        </Grid>
      )}
    </>
  );
}
